var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconCopyMode = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { id: "Icon_feather-copy", transform: "translate(-1.25 -1.25)" },
                React.createElement("path", { d: "M7.5,20H6.3c-1.4,0-2.5-1.1-2.5-2.5V6.3c0-1.4,1.1-2.5,2.5-2.5h11.3c1.4,0,2.5,1.1,2.5,2.5v1.3" }),
                React.createElement("g", null,
                    React.createElement("path", { d: "M27,23.2c-0.2,0.5-0.2,1.1,0.3,1.6l0.1,0.1c0.6,0.6,0.7,1.7,0,2.4c-0.6,0.6-1.7,0.7-2.4,0l0,0\n                        l-0.1-0.1c-0.5-0.5-1.5-0.5-1.9,0c-0.2,0.2-0.4,0.6-0.4,0.9v0.2c0,0.9-0.8,1.6-1.7,1.6c-0.9,0-1.6-0.8-1.6-1.6v-0.1\n                        c0-0.5-0.4-1.1-0.9-1.2c-0.5-0.2-1.1-0.2-1.6,0.3l-0.1,0.1c-0.6,0.6-1.7,0.7-2.4,0c-0.6-0.6-0.7-1.7,0-2.4l0,0l0.1-0.1\n                        c0.5-0.5,0.5-1.5,0-1.9c-0.2-0.2-0.6-0.4-0.9-0.4h-0.2c-0.9,0-1.7-0.7-1.7-1.6c0-1,0.7-1.8,1.6-1.8h0.1h0.1c0.5,0,1.1-0.4,1.2-0.9\n                        c0.2-0.5,0.2-1.1-0.3-1.6l0,0c-0.6-0.6-0.7-1.7,0-2.4c0.7-0.7,1.7-0.7,2.4,0l0,0l0.1,0.1c0.4,0.4,1,0.5,1.6,0.3h0.1\n                        c0.5-0.2,0.9-0.7,0.9-1.2v-0.2c0-0.9,0.7-1.7,1.6-1.7s1.7,0.7,1.7,1.6v0.1v0.1c0,0.8,0.6,1.4,1.4,1.4c0.4,0,0.7-0.2,0.9-0.4\n                        l0.1-0.1c0.6-0.6,1.7-0.7,2.4,0c0.6,0.6,0.7,1.7,0,2.4l0,0l-0.1,0.1c-0.4,0.4-0.5,1-0.3,1.6v0.1c0.2,0.5,0.7,0.9,1.2,0.9h0.2\n                        c0.9,0,1.6,0.8,1.6,1.7c0,0.9-0.8,1.6-1.6,1.6h-0.1C27.7,22.4,27.1,22.7,27,23.2L27,23.2z" }))))));
});
export default IconCopyMode;
//# sourceMappingURL=IconCopyMode.js.map